import Vue from 'vue'
import Router from 'vue-router'

import session from '@/common/js/session.js'
import config from '../config.js'

import PortalSiteRouter from '@/content/portalSite/PortalSiteRouter.js'
import CsysRouter from '@/content/common/csys/CsysRouter.js'


//本页面跳本页面报错
const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error=> error)
} 

Vue.use(Router)

let routesArr = [
  ...PortalSiteRouter,...CsysRouter
];



routesArr.forEach(element => {
  if(!element.meta){
    element.meta = {
      title : element.title,
      power : element.power
    };
  }
  if(element.meta.power==null){
    element.meta.power=false;
  }
  if(!element.path){
  }
  if(!element.name){
    element.name = element.path.replace(/\//g,'-').substr(1);
  }
});
let routerConfig = {
  routes: routesArr
}
//if(config.projectType == 'prod_shhd'){
//  routerConfig.mode='history';
//}
const router = new Router(routerConfig)

router.beforeEach((to, from, next) => {
  if(to.meta.power){
    if(session.getUser()==null){
      router.push({ path: "/login",query: { loginToPageName:  to.name} });
      return;
    }
  }
  next();
});

router.afterEach((route, redirect) => {
  if(route.meta.title){
    window.document.title = route.meta.title;
  }
  document.body.style['overflow-y'] = 'auto';
  window.scrollTo(0,0);
});

router.onError((error) => {
  
});

export default router



// WEBPACK FOOTER //
// ./src/router/index.js